import { Box, CircularProgress } from '@mui/material';
import { Redirect } from 'react-router-dom';
import RenderIf from '../renderIf';
import useClientBasicInfo from './useClientBasicInfo';
import { useEffect } from 'react';
import { useStyles } from './styles';

function CatchAll() {
    const classes = useStyles();
    const { loading, found, retrieveClientBasicInfo } = useClientBasicInfo();

    useEffect(() => {
        retrieveClientBasicInfo();
    }, []);

    return (
        <Box className={classes.catchAllBox}>
            <RenderIf isTrue={loading}>
                <Box className={classes.centeredProgress}>
                    <CircularProgress />
                </Box>
            </RenderIf>
            <RenderIf isTrue={!loading}>
                <RenderIf isTrue={!found}>
                    <Redirect to="/not-found" />
                </RenderIf>
                <RenderIf isTrue={found}>
                    <Redirect to="/signin" />
                </RenderIf>
            </RenderIf>
        </Box>
    );
}

export default CatchAll;
